import styled from "@emotion/styled";
import { Chip, Grid2 } from "@mui/material";

export const GridItem = styled(Grid2)`
  padding: 12px 4px;
  align-self: center;
`;

export const ChipStyled = styled(Chip)`
  width: max-content;
`;
